import { render, staticRenderFns } from "./promocion-prevencion-editar.vue?vue&type=template&id=06bd9736&scoped=true&"
import script from "./promocion-prevencion-editar.vue?vue&type=script&lang=js&"
export * from "./promocion-prevencion-editar.vue?vue&type=script&lang=js&"
import style0 from "./promocion-prevencion-editar.vue?vue&type=style&index=0&id=06bd9736&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bd9736",
  null
  
)

export default component.exports